export class ErrorWithToast extends Error {
  constructor(message: string, public toast: string) {
    super(message);
  }
}
